import {
    GetDeepLinkNavigationActionUseCase
} from "@app/core/shared/application/get-deep-link-navigation-action.use-case";
import {ReplaySubject, Subject, takeUntil} from "rxjs";
import {DeepLinkService} from "@app/core/shared/infrastructure/interfaces/deep-link.service";
import {NavigationAction} from "@app/core/shared/domain/entities/navigation-action";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class DeepLinkViewModel {
    private destroySubject = new Subject();
    private destroy$ = this.destroySubject.asObservable();

    private navigationActionSubject = new ReplaySubject<NavigationAction>(1);
    // Emits a NavigationAction when the app receives a deep link.
    readonly navigationAction$ = this.navigationActionSubject.asObservable();

    private isLoadingSubject = new Subject<boolean>();
    readonly isLoading$ = this.isLoadingSubject.asObservable();

    constructor(
     private getDeepLinkNavigationActionUseCase:GetDeepLinkNavigationActionUseCase,
     private deepLinkService:DeepLinkService,
    ) {}

    /**
     * Initialize view model.
     */
    init() {
        this.listenDeepLink();
    }

    private listenDeepLink() {
        this.deepLinkService.getDeepLink()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: async deepLink => {
                    this.isLoadingSubject.next(true);
                    const navigationAction = await this.getDeepLinkNavigationActionUseCase.execute(deepLink);
                    if (navigationAction === null) {
                        this.isLoadingSubject.next(false);
                        return;
                    }
                    this.navigationActionSubject.next(navigationAction);
                    this.isLoadingSubject.next(false);

                },
                error: () => this.isLoadingSubject.next(false),
            });
    }

    /**
     * Destroy all subscriptions of this view model.
     */
    destroy() {
        this.destroySubject.next(undefined);
        this.destroySubject.complete();
    }
}
